import { ChangeEvent } from 'react'

export const transformLBCurrentInput = {
    input: (value: string | number) => {
        const replacedValue = value && value.toString().replace(/^0+/, '')

        return replacedValue === '' ? '0' : replacedValue
    },
    output: (event: ChangeEvent<HTMLInputElement>) => {
        const output = parseInt(event.target.value, 10)

        return Number.isNaN(output) ? 0 : output
    },
}
